import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
});

export const mapApiToEntity = (data: PropertyType): PropertyType[] => {
	return data.map((item: PropertyType) => ({ label: item.full_name, value: item.id }));
};
